// TODO remove this after deprecating UIComponents part
export const isLegacyComponent = (
  componentProps: any,
  propsList: string[]
): boolean =>
  propsList.some(
    (prop) => Object.keys(componentProps[prop] ?? {}).length !== 0
  );
